import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Map, Sun, Droplet, ShieldCheck, Menu } from 'lucide-react';

const TABS = [
  { id: 'carte', label: 'Carte', route: '/map', icon: Map },
  { id: 'moments', label: 'Météo', route: '/dashboard?focus=meteo', match: '/dashboard', icon: Sun },
  { id: 'blood-tracker', label: 'Pisteur IA', route: '/blood-tracker', icon: Droplet },
  { id: 'permits', label: 'Permis', route: '/permits', icon: ShieldCheck },
  { id: 'plus', label: 'Plus', icon: Menu },
];

export const MobileTabBar = ({ onOpenPlus, plusOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav
      data-testid="mobile-tab-bar"
      className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-[#09090B]/95 backdrop-blur-xl border-t border-white/10 shadow-[0_-4px_20px_rgba(0,0,0,0.6)] pb-[env(safe-area-inset-bottom)]"
    >
      <div className="h-16 flex items-stretch justify-around px-1">
        {TABS.map(({ id, label, route, match, icon: Icon }) => {
          const isPlus = id === 'plus';
          const active = isPlus ? plusOpen : location.pathname.startsWith(match || route.split('?')[0]);
          return (
            <button
              key={id}
              data-testid={`tab-${id}`}
              onClick={() => (isPlus ? onOpenPlus() : navigate(route))}
              className={`relative flex-1 flex flex-col items-center justify-center gap-1 py-1 transition-[color,transform] duration-200 active:scale-95 ${
                active ? 'text-[#F97316] font-bold' : 'text-zinc-400 hover:text-zinc-200'
              }`}
            >
              {active && <span className="absolute -top-px w-8 h-[2px] bg-[#F97316] rounded-full shadow-[0_0_8px_#F97316]" />}
              <Icon size={22} strokeWidth={active ? 2.5 : 2} />
              <span className="text-[10px] uppercase tracking-wider leading-none">{label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
